// หน้าเดิมของระบบที่เปิดใน workspace ของหน้าบอท (Model Creator) — PLAN-model-creator-inline-create.md ข้อ 5.5
// หน้าแม่สร้าง iframe ชื่อ "cf-embed" (origin เดียวกัน) · หน้าในเช็กชื่อหน้าต่าง ไม่ใช้ query เพราะ router.push ในหน้าในทำ query หาย
// ชื่อหน้าต่างอยู่กับ iframe ตลอด (เปลี่ยน route / โหลดใหม่ในกรอบเดิมก็ยังอยู่)
// ข้อความ: { source: 'cf-embed', type, ...payload } ส่งด้วย targetOrigin = origin ของเว็บเอง
//   created         { kind, id, name } — บันทึกสำเร็จ (หน้าแม่โหลดรายการใหม่แล้วเลือกให้)
//   dirty           { dirty }          — มี/ไม่มีงานที่ยังไม่ได้บันทึก (หน้าแม่ถามก่อนปิด)
//   close                              — หน้าในขอปิด workspace (ปุ่มย้อนกลับของหน้าใน — ผู้ใช้ยืนยันในหน้าในแล้ว)
//   session-expired                    — API ในหน้าในได้ 401 (หน้าแม่ปิด workspace แล้วพาไป login เอง)

export const EMBED_WINDOW_NAME = 'cf-embed';
export const EMBED_SOURCE = 'cf-embed';
export const EMBED_EVENTS = Object.freeze({
  created: 'created',
  dirty: 'dirty',
  close: 'close',
  sessionExpired: 'session-expired',
});

const KNOWN_TYPES = new Set(Object.values(EMBED_EVENTS));

// หน้านี้เปิดอยู่ใน workspace ของหน้าบอท (iframe ชื่อ cf-embed ที่หน้าแม่ origin เดียวกัน)
export function isEmbedded(win = globalThis) {
  try {
    if (!win || win.self === win.top || win.name !== EMBED_WINDOW_NAME) return false;
    // หน้าแม่ต่าง origin = อ่าน location ไม่ได้ (throw) → ไม่ใช่ workspace ของเรา
    return win.parent.location.origin === win.location.origin;
  } catch {
    return false;
  }
}

// ส่งข้อความถึงหน้าแม่ — คืน false เมื่อไม่ได้อยู่ใน workspace (ไม่ส่งอะไร)
export function notifyParent(type, payload = {}, win = globalThis) {
  if (!KNOWN_TYPES.has(type) || !isEmbedded(win)) return false;
  try {
    win.parent.postMessage({ ...payload, source: EMBED_SOURCE, type }, win.location.origin);
    return true;
  } catch {
    return false;
  }
}

// ฝั่งหน้าแม่: ข้อความจาก iframe ของ workspace ที่เชื่อได้ — origin เดียวกัน + มาจาก iframe นั้นจริง + รูปแบบถูก
// คืน data ของข้อความ หรือ null
export function readEmbedMessage(event, frameWindow, win = globalThis) {
  if (!event || !frameWindow || event.source !== frameWindow) return null;
  if (event.origin !== win.location.origin) return null;
  const data = event.data;
  if (!data || typeof data !== 'object' || data.source !== EMBED_SOURCE || !KNOWN_TYPES.has(data.type)) return null;
  return data;
}
